import React, { Suspense, ReactNode } from 'react';
import { ErrorBoundary } from '@/components/ErrorBoundary';
import { TenantProvider } from '@/contexts/TenantContext';
import { MarketingProvider } from '@/components/MarketingProvider';
import { SyncProvider } from '@/contexts/SyncContext';
import { TenantMarketplace } from '@/components/TenantMarketplace';
import { PageLoader } from '@/components/LazyComponents';

interface RouteWrapperProps {
  children: ReactNode;
  withTenant?: boolean;
  withMarketing?: boolean;
  withSync?: boolean;
  withTenantMarketplace?: boolean;
}

/**
 * HOC que encapsula providers comuns para rotas
 * Elimina duplicação de código entre rotas
 */
export const RouteWrapper: React.FC<RouteWrapperProps> = ({
  children,
  withTenant = false,
  withMarketing = false,
  withSync = false,
  withTenantMarketplace = false,
}) => {
  let content = <Suspense fallback={<PageLoader />}>{children}</Suspense>;

  // Aplicar providers de dentro para fora
  if (withTenantMarketplace) {
    content = <TenantMarketplace>{content}</TenantMarketplace>;
  }

  if (withSync) {
    content = <SyncProvider>{content}</SyncProvider>;
  }

  if (withMarketing) {
    content = <MarketingProvider>{content}</MarketingProvider>;
  }

  if (withTenant) {
    content = <TenantProvider>{content}</TenantProvider>;
  }

  return <ErrorBoundary>{content}</ErrorBoundary>;
};
